/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { logger } from '~/utils/sentry/client-only-logger'
import { analytics } from './segment-analytics'
import {
  withPrefix,
  getPageEventParams,
  getLinkEventParams,
  getPageLocationEventParams,
} from './utils'
import { useCommonTrackingDataState } from './useCommonTrackingDataState'
import type {
  PageTrackingData,
  PageLocationTrackingData,
  LinkTrackingData,
  CommonTrackingData,
} from '~/types/tracking'

type Params = PageTrackingData & PageLocationTrackingData & LinkTrackingData

const trackLinkClick = (params: Params) => {
  const eventParams = {
    ...getPageEventParams(params),
    ...getPageLocationEventParams(params),
    ...getLinkEventParams(params),
  }

  analytics
    .track(withPrefix('Link clicked'), eventParams)
    .catch((e: unknown) => {
      logger.error(e)
    })
}

export const useTrackLinkClick = () => {
  const commonTrackingData = useCommonTrackingDataState()

  return clientOnly(
    (params: Prettify<Omit<Params, keyof CommonTrackingData>>) => {
      trackLinkClick({ ...params, ...commonTrackingData.value })
    },
  )
}
